<template>
  <div class="colored-notes" :class="{ 'colored-notes--indent': indent }" :style="cssProps">
    <div class="colored-notes__text"><slot>{{ text }}</slot></div>
    <div class="colored-notes__border" :style="{ backgroundColor: color }"></div>
  </div>
</template>

<script>
export default {
  name: 'AppColoredNotes',
  props: {
    color: {
      type: String,
      default: '#77b017'
    },
    text: {
      type: String,
      default: ''
    },
    indent: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    cssProps() {
      return {
        '--bg-color': this.hexToRgb(this.color),
      }
    }
  },
  methods: {
    hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : '#77b017'
    }
  }
}
</script>

<style scoped lang="sass">
.colored-notes
  position: relative
  max-width: 1080px
  border-radius: 0 12px 12px 0
  overflow: hidden

.colored-notes--indent
  margin-bottom: 15px

.colored-notes--indent-30
  margin-bottom: 30px

.colored-notes__text
  padding: 20px 20px 20px 25px
  color: #191f0f
  font-size: 15px
  background-color: rgba(var(--bg-color), 0.1)
  white-space: pre-wrap

.colored-notes__border
  position: absolute
  top: 0
  left: 0
  width: 3px
  height: 100%

</style>
